import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

// crops
export const getCrop = createAsyncThunk("getCrop", async (id) => {
  const res = await axios.get(`/api/crop?id=${id}`);
  return res.data;
});

export const getCrops = createAsyncThunk(
  "getCrops",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/crop/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addCrop = createAsyncThunk(
  "addCrop",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { name, code, unit } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name, code, unit });
      const res = await axios.post("api/crop", body, config);
      successAlertHandle("Crop added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateCrop = createAsyncThunk(
  "updateCrop",
  async ({ id, name, code, unit }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ id, name, code, unit });
      const res = await axios.put("api/crop", body, config);
      successAlertHandle("Crop updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteCrop = createAsyncThunk(
  "deleteCrop",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/crop?id=${id}`);
      successAlertHandle("Crop deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// varieties
export const getVariety = createAsyncThunk("getVariety", async (id) => {
  const res = await axios.get(`/api/variety?id=${id}`);
  return res.data;
});

export const getVarieties = createAsyncThunk(
  "getVarieties",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/variety/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addVariety = createAsyncThunk(
  "addVariety",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { code, name, crop } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ code, name, crop });
      const res = await axios.post("api/variety", body, config);
      successAlertHandle("Variety added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateVariety = createAsyncThunk(
  "updateVariety",
  async ({ id, code, name, crop }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ id, code, name, crop });
      const res = await axios.put("api/variety", body, config);
      successAlertHandle("Variety updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteVariety = createAsyncThunk(
  "deleteVariety",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/variety?id=${id}`);
      successAlertHandle("Variety deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

//grades

export const getGrade = createAsyncThunk("getGrade", async (id) => {
  const res = await axios.get(`/api/grade?id=${id}`);
  return res.data;
});

export const getGrades = createAsyncThunk(
  "getGrades",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/grade/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addGrade = createAsyncThunk(
  "addGrade",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { name, code, price, variety } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name, code, price, variety });
      const res = await axios.post("/api/grade", body, config);
      successAlertHandle("Grade added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateGrade = createAsyncThunk(
  "updateGrade",
  async (
    { id, name, code, price, variety },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        id,
        name,
        code,
        price,
        variety,
      });
      const res = await axios.put("/api/grade", body, config);
      successAlertHandle("Grade updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteGrade = createAsyncThunk(
  "deleteGrade",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/grade?id=${id}`);
      successAlertHandle("Grade deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

//hooks

export const getCropsNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/crop/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getVarietiesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/variety/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getGradesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/grade/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};
